export interface CampaignsContextValue {
  activeCampaign?: Campaigns
  currentDiscount: number
  applyDiscount: (price: number) => number
}

export enum Campaigns {
  Christmas = 'christmas2025',
  BlackFriday = 'blackFriday2025',
}
